export const authenticate = (isAuthenticated) => ({
	type: 'AUTHENTICATE',
	payload: isAuthenticated,
});
